export default {
    name: "neo-checkbox",
    components: {},
    props: ["value", "label", "bg", "borderColor", "disabled", "validation"],

    data() {
        return {
            isChecked: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isChecked = val;
            }
        }
    }, 
    methods: {
        async handleChange(event) {
            const newValue = event.target.checked;
            // Perform validation
            const validationPassed = typeof this.validation === 'function' ? await this.validation(newValue) : true;
            if (validationPassed) {
                // Update state only if validation passes
                this.$emit('input', newValue)
            } else {
                // Revert state if validation fails
                event.target.checked = this.isChecked;
            }
        }
    },
};
